<template>
    <v-form ref="commonForm" v-model="validateCurrent" @submit.prevent="saveSettingData">
        <v-card class="pa-0 pa-sm-4" v-bind:class="{ 'rounded-xl' : !$vuetify.breakpoint.mobile, 'full-with': $vuetify.breakpoint.mobile }" flat>
            <v-card-title v-if="isProfileModal" class="pr-1">
                <v-col cols="12" class="ma-0 pa-0">
                    <v-row justify="end" align="center" class="ma-0 pa-0">
                        <v-spacer></v-spacer>
                        <v-hover v-slot="{hover}">
                            <v-btn v-if="$vuetify.breakpoint.mobile"
                                   :color="hover ? 'linkHover' : 'primary'"
                                   text
                                   plain
                                   :disabled="!changed || formProcess || !validateCurrent"
                                   type="submit"
                                   class="text-large"
                                   @click="saveSettingData">
                                   {{ formatMenuText($t('account.save')) }}
                                   <v-progress-circular v-if="formProcess" class="ml-2" indeterminate color="primary"></v-progress-circular>
                            </v-btn>
                        </v-hover>
                        <v-hover v-slot="{hover}">
                            <v-btn v-if="closeButtonVisibility && $vuetify.breakpoint.mobile"
                                   :color="hover ? 'linkHover' : 'warning'"
                                   text
                                   plain
                                   class="text-large"
                                   @click="closeDialog()"
                                   :aria-label="$t('account.close')">
                                {{ formatMenuText($t('account.close')) }}
                            </v-btn>
                            <v-btn v-else-if="closeButtonVisibility"
                                   :color="hover ? 'linkHover' : 'primary'"
                                   icon
                                   plain
                                   class="text-none text-large"
                                   @click="closeDialog()"
                                   :aria-label="$t('account.close')">
                                <v-icon height="24px" width="24px" aria-hidden="true">mdi-close</v-icon>
                            </v-btn>
                        </v-hover>
                    </v-row>

                    <v-row class="ma-2">
                        {{ formatMenuText($t('account.settings')) }}
                    </v-row>
                    <v-alert v-if="showPasswordWarning" type="warning" dense class="ma-1" v-bind:class=" { 'text-small': $vuetify.breakpoint.mobile }">
                        <span v-if="showPasswordExpired" class="better-break" v-html="$t('account.passwordExpired')"></span>
                        <span v-else class="better-break">{{ $t('account.PleaseConfigurePassword') }}</span>
                    </v-alert>
                    <v-alert v-if="sendError" type="error" dense class="ma-1 better-break" v-bind:class=" { 'text-small': $vuetify.breakpoint.mobile }" dismissible>{{ $t(errorMsg) }}</v-alert>
                    <v-alert v-if="sendSuccess" type="success" dense class="ma-1 better-break" v-bind:class=" { 'text-small': $vuetify.breakpoint.mobile }" dismissible>{{ $t(successMsg) }}</v-alert>
                </v-col>
                <v-tabs v-model="selectedTab" fixed-tabs :show-arrows="$vuetify.breakpoint.mobile" @change="$refs.commonForm.resetValidation()">
                    <v-tab v-show="ShowUserInfo" 
                           dense
                           class="override-spaces"
                           @click="clickTab('user')">{{ formatMenuText($t('account.profile')) }}</v-tab>
                    <v-tab v-if="ShowPasswordManager" 
                           dense
                           class="override-spaces"
                           @click="clickTab('password')">{{ formatMenuText($t('account.password')) }}</v-tab>
                </v-tabs>
            </v-card-title>
            <v-card-text v-bind:class="{ 'no-overflow': $vuetify.breakpoint.height < 500 }">
                <v-tabs-items v-model="selectedTab">
                    <v-tab-item ref="tab_0" v-show="ShowUserInfo">
                        <user-information :disabled="nameFromSelected !== 'user' " 
                                          :value="editableUserData" 
                                          @changed="onNewUserInfo"
                                          @phoneValidate="onPhoneValidate"/>
                    </v-tab-item>
                    <v-tab-item ref="tab_1" v-if="ShowPasswordManager">
                        <password-manager :disabled="nameFromSelected !== 'password'" 
                                          :value="editabledPasswordData" 
                                          @changed="onSetNewPassword" />
                    </v-tab-item>
                </v-tabs-items>
            </v-card-text>
            <v-card-actions>
                <v-row class="pa-2 mb-1 mb-sm-0" align="center">
                    <v-btn v-if="!$vuetify.breakpoint.mobile"
                           color="primary"
                           type="submit"
                           class="text-normal white--text min-height-1"
                           :disabled="!changed || formProcess || !validateCurrent || !phoneValidate"
                           block depressed
                           @click="saveSettingData">
                        {{ formatMenuText($t('save')) }}
                        <v-progress-circular v-if="formProcess" class="ml-2" indeterminate color="white"></v-progress-circular>
                    </v-btn>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<style scoped>
    .override-spaces {
        word-break: break-word !important;
    }
    .full-with {
        overflow-x: hidden;
        width: 100%;
    }
    .no-overflow {
        overflow-y: hidden !important;
        min-height: 400px
    }
</style>
<script>
    import { mapState } from "vuex";
    import UserInformation from "./userInformation"
    import PasswordManager from "./passwordManager"

    export default {
        name: "settings",
        components: { UserInformation, PasswordManager },
        props: [
            'ShowUserInfo',
            'ShowPasswordManager',
            'isProfileModal',
            'isLegalModal',
            'MustSetPassword',
            'PasswordExpired',
            'SecurityData',
            'UserData',
        ],
        data: function () {
            return {
                validateCurrent: false,
                phoneValidate: true,
                passwordSet: false,
                userInfoChanged: false,
                passwordChanged: false,
                selectedTab: 0,
                formProcess: false,
                tabName: undefined,
                sendError: false,
                sendSuccess: false,
                errorMsg: undefined,
                successMsg: undefined,
                editableUserData: undefined,
                editabledPasswordData: {
                    OldPassword: undefined,
                    NewPassword: undefined,
                    ConfPassword: undefined
                },
                showPasswordWarning: false,
                showPasswordExpired: false
            };
        },
        mounted: function () {
            if (this.UserData != null)
                this.editableUserData = structuredClone(this.UserData);
            this.showPasswordWarning = this.MustSetPassword;
            this.showPasswordExpired = this.PasswordExpired;
            if (this.ShowUserInfo)
                this.tabName = 'user';
            else
                if (this.ShowPasswordManager) {
                    this.tabName = 'password';
                    this.selectedTab = 1;
                }
        },
        watch: {
            UserData(newVal) {
                if (newVal != null && (this.editableUserData == null || this.editableUserData.Id != newVal.Id)) {
                    this.editableUserData = structuredClone(newVal);
                    this.editabledPasswordData = {
                        OldPassword: undefined,
                        NewPassword: undefined,
                        ConfPassword: undefined
                    }
                }
            },
            MustSetPassword(newVal) {
                this.showPasswordWarning = newVal;
            }
        },
        computed: {
            ...mapState("account", ["status", "user"]),
            closeButtonVisibility() {
                return !(this.MustSetPassword && !this.passwordSet);
            },
            changed() {
                var name = this.nameFromSelected;
                return (name == 'user' && this.userInfoChanged) ||
                    (name == 'password' && this.passwordChanged);
            },
            currentTabName() {
                if (this.tabName != null) return this.tabName;
                if (this.ShowUserInfo)
                    return 'user'
                else
                    if (this.ShowPasswordManager)
                        return 'password'
                return undefined;
            },
            nameFromSelected() {
                var index = -1;
                for (var i = 0; i < 3; i++) {
                    if (this.$refs[`tab_${i}`] != null) {
                        index++;
                    }
                    if (index == this.selectedTab) {
                        switch (i) {
                            case 0: return 'user';
                            case 1: return 'password';
                        }
                    }
                }
                return this.tabName;
            }
        },
        methods: {
            formatMenuText(text) {
                if (!text) return text;

                // Check the titleCase setting from the current experience
                const titleCase = this.$experience.titleCase !== false; // default to true if not set

                if (titleCase) {
                    // Title case: capitalize first letter of all words
                    return text.split(' ').map(word => {
                        if (word.length === 0) return word;
                        // Check if word is an acronym (all uppercase)
                        if (word === word.toUpperCase() && word.length > 1) {
                            return word; // Keep acronyms as-is
                        }
                        return word.charAt(0).toUpperCase() + word.slice(1);
                    }).join(' ');
                } else {
                    // Sentence case: only capitalize first letter of first word
                    // But preserve acronyms
                    const words = text.split(' ');
                    return words.map((word, index) => {
                        if (word.length === 0) return word;
                        // Check if word is an acronym (all uppercase)
                        if (word === word.toUpperCase() && word.length > 1) {
                            return word; // Keep acronyms as-is
                        }
                        if (index === 0) {
                            // First word: capitalize first letter
                            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                        } else {
                            // Other words: all lowercase
                            return word.toLowerCase();
                        }
                    }).join(' ');
                }
            },
            clickTab(name) {
                this.tabName = name;
            },
            onNewUserInfo() {
                this.userInfoChanged = true;
                this.$refs['commonForm'].validate();
            },
            onSetNewPassword() {
                this.passwordChanged = true;
                this.$refs['commonForm'].validate();
            },
            onPhoneValidate(val) {
                this.phoneValidate = val;
            },
            saveSettingData() {
                this.tabName = this.currentTabName;
                if (this.validateCurrent) {
                    this.sendError = false;
                    this.formProcess = true;
                    if (this.tabName === 'user') {
                        this.saveUser().then(() => {
                            this.userInfoChanged = false;
                            this.$emit("userDataUpdated", this.editableUserData);
                            if (this.MustSetPassword && this.ShowPasswordManager) {
                                this.tabName = 'password';
                                this.selectedTab++;
                            }
                        });
                    }
                    else
                        if (this.tabName === 'password') {
                            this.setNewPassword().then(() => {
                                this.passwordSet = true;
                                this.passwordChanged = false;
                                this.showPasswordWarning = false;
                                this.editabledPasswordData.OldPassword = undefined;
                                this.editabledPasswordData.ConfPassword = undefined;
                                this.editabledPasswordData.NewPassword = undefined;

                                this.selectedTab = 0;
                                this.tabName = 'user';

                                this.$nextTick(() => {
                                    this.$refs.commonForm.resetValidation();
                                })
                                if (this.MustSetPassword) {
                                    this.closeDialog();
                                }
                            });
                        }
                }
            },
            saveUser() {
                const data = this.editableUserData;
                return this.$axios.post('account/set-user-info', data).then((response) => {
                    this.formProcess = false;
                    if (!response.data.success) {
                        this.showError(response.data.msg);
                        throw this.errorMsg;
                    } else {
                        this.showSuccess(response.data.msg);
                    }
                }).catch((error) => {
                    this.showError(error);
                    throw error;
                });
            },
            setNewPassword() {
                const data = this.editabledPasswordData;
                return this.$axios.post('account/set-new-password', data).then((response) => {
                    this.formProcess = false;
                    if (!response.data.success) {
                        this.showError(response.data.msg);
                        throw this.errorMsg;
                    } else
                        this.showSuccess(response.data.msg);
                }).catch((error) => {
                    this.formProcess = false;
                    this.showError(error);
                    throw error;
                });
            },
            showError(message) {
                this.sendError = true;
                this.errorMsg = message;
                setTimeout(() => {
                    this.sendError = false;
                }, 7000);
            },
            showSuccess(message) {
                this.sendSuccess = true;
                this.successMsg = message;
                setTimeout(() => {
                    this.sendSuccess = false;
                }, 7000);
            },
            closeDialog() {
                this.editableUserData = structuredClone(this.UserData);
                this.$emit('close-modal');
            }
        }
    };
</script>